<template>
  <div v-if="visible" class="w-full border border-amber-300 bg-amber-50 text-amber-900" role="status">
    <div class="px-3 sm:px-4 py-1.5 flex items-center justify-between gap-3 text-sm">
      <p class="whitespace-nowrap overflow-hidden text-ellipsis">
        {{ t('banner.setupMessage') }}
      </p>
      <button @click="dismiss"
        class="shrink-0 inline-flex items-center justify-center h-6 w-6 rounded hover:bg-amber-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-500 text-amber-900/80 hover:text-amber-900"
        :aria-label="t('banner.dismissLabel')" :title="t('banner.dismissLabel')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const STORAGE_KEY = 'announcementBanner:dismissed:v1';
const isProd = import.meta.env.PROD;

const dismissed = ref(false);

// Initialize dismissed from localStorage if available
if (typeof window !== 'undefined') {
  try {
    dismissed.value = window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    // ignore storage errors (e.g., privacy mode)
  }
}

//const visible = computed(() => isProd && !dismissed.value);
const visible = false;

function dismiss() {
  dismissed.value = true;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // ignore storage errors
    }
  }
}
</script>
